import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IUserEmailNotification } from 'src/app/modules/admin/models';
import { IUserEmailNotificationHistory } from 'src/app/modules/admin/models/cloudwatch';
import { CloudwatchService } from 'src/app/modules/admin/services/cloudwatch.service';

@Component({
  selector: 'app-email-history-dialog',
  templateUrl: './email-history-dialog.component.html',
  styleUrls: ['./email-history-dialog.component.scss']
})
export class EmailHistoryDialogComponent implements OnInit {

  history: IUserEmailNotificationHistory[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IUserEmailNotification,
    private cloudwatch: CloudwatchService) 
    { }
  
    ngOnInit(): void {
      this.cloudwatch.getUserEmailNotificationHistory(this.data.sendGridMessageId).subscribe((history) => {
        // console.log("Email History fetched successfully: ", history);
        this.history = history;
      });
    }
}
